// extracted by mini-css-extract-plugin
module.exports = {"Button":"SectionB_Button__3VtR4","Shape":"SectionB_Shape___AuiH","Bicycle":"SectionB_Bicycle__1xmg-","TextContainer":"SectionB_TextContainer__1Xjpb"};